import type { IconNode } from '../types';

/**
 * @name chart-radar
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMnYxMCIgLz4KICA8cGF0aCBkPSJtMTYgMTggMy4wODUtOC4xMjVMMTIgNC4xMDMgMy40NzMgOS40NDJsMy4xOTYgMTAuNTU0eiIgLz4KICA8cGF0aCBkPSJtMiA5IDEwIDMgNiA5IiAvPgogIDxwYXRoIGQ9Im02IDIxIDYtOSAxMC0zIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/chart-radar
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const ChartRadar: IconNode = [
  ['path', { d: 'M12 2v10' }],
  ['path', { d: 'm16 18 3.085-8.125L12 4.103 3.473 9.442l3.196 10.554z' }],
  ['path', { d: 'm2 9 10 3 6 9' }],
  ['path', { d: 'm6 21 6-9 10-3' }],
];

export default ChartRadar;
